<div class="modal-header">
  <h4 class="modal-title h5" translate>Machine Cloning</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <div translate>The following machine will be created:</div>
  <div><strong [innerText]="machine.name"></strong></div>
  <br />
  <div translate>The settings will be copied from machine:</div>
  <div><strong [innerText]="sourceMachineName"></strong></div>
  <br />
  <div translate>The following settings will be copied:</div>

  <div>
    <ul>
      @if (copySetting.copyDataConfiguration) {
        <li translate>Signals</li>
      }
      @if (copySetting.copyStatusIndicator) {
        <li translate>Status indicator</li>
      }
      @if (copySetting.copyTrafficLightConfiguration) {
        <li translate>Traffic Light</li>
      }
      @if (copySetting.copyTileConfiguration) {
        <li translate>Tile</li>
      }
      @if (copySetting.copyInlineFrameCockpitConfiguration) {
        <li translate>Inline Frame Pages</li>
      }
      @if (copySetting.copyExternalUrlConfiguration) {
        <li translate>External URL Nodes</li>
      }
      @if (copySetting.copyTableauConfiguration) {
        <li translate>Tableau Views</li>
      }
    </ul>
  </div>
  <hr />
  @if (usedTables.length > 0) {
    <div>
      <strong><span class="font-weight-bold text-danger" translate>Note:</span></strong>
      <span translate>The following tables will be used when the signals are copied:</span>
      <div>
        <ul>
          @for (usedTable of usedTables; track usedTable) {
            <li [innerText]="usedTable"></li>
          }
        </ul>
      </div>
    </div>
  }
  <div></div>
  <div>Please make sure that the created gateways, use the same table names or review and adjust the data
  configuration settings.</div>
</div>
<div class="modal-footer">
  <button type="sbuttonubmit" class="btn btn-primary" (click)="onOk()">
    <span translate>Save</span>
  </button>
</div>